import { ProviderOfflinePeriod } from '@provider-portal/common/api/gen/DeliveryProviderPortalAuthApi';
import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import {
  cancelOfflinePeriodAsyncAction,
  createOfflinePeriodAsyncAction,
  getOfflinePeriodsAsyncAction,
  OfflinePeriodsActions,
} from './actions';

export interface OfflinePeriodsState {
  offlinePeriods: ProviderOfflinePeriod[];
  fetchingState: NetworkRequestState;
  error?: string;
  cancelError?: Error;
  createRequestState: NetworkRequestState;
  cancelRequestState: NetworkRequestState;
}

const initialState: OfflinePeriodsState = {
  offlinePeriods: [],
  fetchingState: NetworkRequestState.unset,
  createRequestState: NetworkRequestState.unset,
  cancelRequestState: NetworkRequestState.unset,
};

export const offlinePeriodsReducer = (
  state: OfflinePeriodsState = initialState,
  action: OfflinePeriodsActions,
): OfflinePeriodsState => {
  switch (action.type) {
    case getType(getOfflinePeriodsAsyncAction.request): {
      return {
        ...state,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(getOfflinePeriodsAsyncAction.success): {
      return {
        ...state,
        offlinePeriods: action.payload.offline_periods,
        fetchingState: NetworkRequestState.success,
        createRequestState: NetworkRequestState.unset,
        cancelRequestState: NetworkRequestState.unset,
        error: null,
      };
    }
    case getType(getOfflinePeriodsAsyncAction.failure): {
      return {
        ...state,
        fetchingState: NetworkRequestState.failure,
      };
    }
    case getType(createOfflinePeriodAsyncAction.request): {
      return {
        ...state,
        createRequestState: NetworkRequestState.waiting,
      };
    }
    case getType(createOfflinePeriodAsyncAction.success): {
      return {
        ...state,
        createRequestState: NetworkRequestState.success,
      };
    }
    case getType(createOfflinePeriodAsyncAction.failure): {
      return {
        ...state,
        error: action.payload.response.error_hint,
        createRequestState: NetworkRequestState.failure,
      };
    }
    case getType(cancelOfflinePeriodAsyncAction.request): {
      return {
        ...state,
        cancelRequestState: NetworkRequestState.waiting,
      };
    }
    case getType(cancelOfflinePeriodAsyncAction.success): {
      return {
        ...state,
        cancelRequestState: NetworkRequestState.success,
      };
    }
    case getType(cancelOfflinePeriodAsyncAction.failure): {
      return {
        ...state,
        cancelRequestState: NetworkRequestState.failure,
        cancelError: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
